
import SparkMD5 from "spark-md5";
import {getLocalStorageForUser, removeLocalStorageForUser, setLocalStorageForUser} from "./localstorage";
import getCosUploading from "./cos.config";
import CryptoJS from "crypto-js";
import {getFileSuffix} from "./index";
import {v4 as uuidv4} from "uuid";
import Compressor from 'compressorjs';

import Axios from "axios";
import qs from "qs";
import instance from "@/axios.config";
import {Toast} from "vant"; // 图片压缩库
// 统一上传服务：支持 0-本地、1-COS、2-OSS、3-S3
// 对外仅暴露统一的 upload(file, options) 与取消能力，返回 { fileId, url?, extra? }

const MB = 1024 * 1024;
const LOCAL_SHARD_THRESHOLD_MB = 50; // 本地直传分片阈值：50MB
const S3_MIN_PART_SIZE_MB = 20; // S3 分片上传推荐分片：20MB（S3 最小要求是≥5MB）
const LOCAL_PART_SIZE_MB = 20; // 本地分片大小：20MB

function getSafeUrl(url) {
  if (!url) return ''
  return url.startsWith('http') ? url : `http://${url}`
}
function createAbortController() {
  if (typeof AbortController !== "undefined") {
    return new AbortController();
  }
  return null;
}

function detectContentType(file) {
  return file.type || "application/octet-stream"
}
function ensureTrailingSlash(url) {
  return url.endsWith('/') ? url : url + '/'
}
function choosePartSize(fileSize, minPartMB, targetParts = 1000) {
  const minBytes = minPartMB * MB
  const rough = Math.ceil(fileSize / targetParts)
  return Math.max(minBytes, rough)
}
function  generateUUID() {
  return uuidv4()
}
//生成随机路径和名称
function generateFilePath(fileType,typeUpload,TOKEN_VALUE) {
  // 获取当前日期
  const now = new Date()
  // 获取年、月、日，并确保月和日格式始终是两位数
  const year = now.getFullYear()
  const month = (now.getMonth() + 1).toString().padStart(2, '0') // 月份是从0开始的
  const day = now.getDate().toString().padStart(2, '0')
  const randomChars = generateUUID().replace(/-/g, '') // 使用之前的generateUUID函数，并去除破折号
  // 构建文件名
  const fileName = `${randomChars}${fileType}`;
  // 拼接完整的路径
  const dir = getLocalStorageForUser(TOKEN_VALUE,'pathPrefix')?getLocalStorageForUser(TOKEN_VALUE,'pathPrefix') : 'public'
  const filePath = `${dir}/${typeUpload}/${year}/${month}/${day}/${fileName}`;
  return filePath;
}
//定义分类
const fileTypes = {
  videoType: ['.mp4', '.mrv', '.mov', '.mpg', '.mpeg', '.ts', '.swf', '.flv', '.wmv', '.avi', '.mkv'],
  audioType: ['.aac', '.flac', '.ogg', '.ape', '.wav', '.mp3', '.wma'],
  docType: ['.pdf', '.xls', '.xlsx','.ppt','.pptx','.doc','.docx','.txt','.wps','.wpss','.docm','.dotm','.dot','.dotx','.html','pot','potx','pps','ppsx','dps','dpt','pptm','potm','ppsm','dpss'],
  imageType: ['.jpg', '.jpeg', '.png', '.gif'],
  apkType: ['.apk']
};
// 处理文件分类
function classifyFileTypes(extension) {
  if (fileTypes.videoType.includes(extension)) {
    return 'video';
  } else if (fileTypes.audioType.includes(extension)) {
    return 'audio';
  } else if (fileTypes.docType.includes(extension)) {
    return 'doc';
  } else if (fileTypes.imageType.includes(extension)) {
    return 'image';
  }else {
    return 'apk';
  }
}
//cos上传时间戳判断
function isTimestampExpired(expireTime) {
  // 将当前时间转换为秒（因为 expireTime 是以秒为单位的）
  const currentTimeInSeconds = Math.floor(Date.now()/1000) + 60
  // 比较当前时间和过期时间
  if(currentTimeInSeconds >= expireTime){
    return true;
  }

}

function decode(data) {
  try {
    var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
    key = CryptoJS.enc.Hex.parse(key)
    let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
    var dec = CryptoJS.AES.decrypt(CryptoJS.format.Hex.parse(data.data), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })

    return JSON.parse(CryptoJS.enc.Utf8.stringify(dec))
  } catch (e) {
    console.info(e);
  }
  return ''

}
class UploadService {
  constructor() {
    this.upFileUrl = localStorage.getItem("upFileUrl") || "/"
    this.currentControllers = new Set();
    this.uploadType = 0; // { uploadType: 0|1|2|3, ... }
    this.usageScene = 1 //场景(0-临时文件 1-素材文件 2-系统 3-升级包 4-用户logo)
    this.fileUrl = null
    this.thumbUrl = null
    this.TOKEN_VALUE = null // 初始化 TOKEN_VALUE
    // 上传任务跟踪
    this.currentUploadTasks = new Map(); // 存储当前上传任务信息 { fileMd5: { type, shardUploadId?, cosTaskId?, ossController? } }
  }



  // 统一上传入口
  async upload(file, usageScene, TOKEN_VALUE, uploadType, { onProgress } = {}) {

    this.uploadType = uploadType
    this.usageScene = usageScene
    this.TOKEN_VALUE = TOKEN_VALUE

    return await this.preUploadCheck(file, { onProgress })
  }

  cancelAll() {
    this.currentControllers.forEach((c) => c.abort())
    this.currentControllers.clear()
    this.currentUploadTasks.clear()
  }

  // 统一取消上传方法
  async cancelUpload(fileMd5) {
    if (!fileMd5) {
      // 如果没有指定 fileMd5，取消所有上传
      this.cancelAll()
      return
    }

    const task = this.currentUploadTasks.get(fileMd5)
    if (!task) {
      console.warn(`未找到文件 ${fileMd5} 的上传任务`)
      return
    }

    try {
      const { type, shardUploadId } = task

      if (type === 0) {
        // 标记为已取消并中断所有请求
        task.cancelled = true
        this.currentUploadTasks.set(fileMd5, task)

        // 取消所有控制器（使用传统判断，避免 undefined 错误）
        if (task.mainController) {
          task.mainController.abort()
        }
        if (task.controller) {
          task.controller.abort()
        }
        this.currentControllers.forEach(c => {
          if (c) {
            c.abort()
          }
        })

        // 调用后端取消接口
        if (shardUploadId) {
          await instance.post(this.upFileUrl +'etv/cancelUpload.json', qs.stringify({ shardUploadId }))
              .catch(() => {}) // 忽略错误，已标记为取消
        }
      } else if (type === 3) {
        // S3 上传：设置取消标志并中断所有正在进行的请求
        task.cancelled = true
        this.currentUploadTasks.set(fileMd5, task)

        // 中断所有分片上传的 CancelToken Source

        if (task.partCancelSources && task.partCancelSources.length > 0) {
          task.partCancelSources.forEach((source, index) => {
            try {
              if (source && typeof source.cancel === 'function') {
                source.cancel('S3 上传已取消')
              }
            } catch (e) {
              console.error(`S3 取消上传：中断分片上传 ${index + 1} 失败`, e)
            }
          })
        }

        // 同时中断所有全局控制器（双重保险）

        this.currentControllers.forEach(c => {

          if (c && typeof c.abort === 'function') {
            if (!c.signal || !c.signal.aborted) {
              c.abort()

            }
          }

        })

      } else if (type === 1) {
        const { cosInstance, cosTaskId } = task
        if (cosTaskId && cosInstance) {
          cosInstance.cos.cancelTask(cosTaskId)
        } else if (cosInstance && cosInstance.taskId) {
          cosInstance.cos.cancelTask(cosInstance.taskId)
        }
      } else if (type === 2) {
        // OSS 上传：通过 CancelToken 终止请求
        task.cancelled = true
        this.currentUploadTasks.set(fileMd5, task)
        if (task.ossCancelSource) {
          task.ossCancelSource.cancel('取消 OSS 上传')
        }
      }

      // 从任务列表中移除
      this.currentUploadTasks.delete(fileMd5)
    } catch (error) {
      console.error('取消上传失败:', error)
      throw error
    }
  }
  async preUploadCheck(file, {onProgress} = {}) {
    this.fileUrl = ''
    this.thumbUrl = ''
    file.onProgress = onProgress // 设置进度回调
    const initResp = await Axios.post("/etv/preUploadCheck.json", qs.stringify({
      fileName:file.name,
      fileType:file.type,
      fileMd5: file.fileMd5,
      uploadType: this.uploadType,
      fileSize: file.size,
      usageScene: this.usageScene
    }))
    if (initResp.data.code === 1) {
      file.msg = initResp.data.msg
      Toast(file.msg)
      return
    }
    if (initResp.data.data && initResp.data.data.fileId) {

      // 模拟进度条：快速从 0% 到 100%，让用户看到完整进度
      if (onProgress) {
        if (onProgress) {
          onProgress(0)
          // 使用 setTimeout 确保 UI 有时间更新
          setTimeout(() => {
            if (onProgress) onProgress(100)
          }, 100)
        }
      }
      return {
        result: initResp.data.data.fileId || ''
      }
    }else {
      if (this.uploadType === 0) {
        // 本地直传
          if (file.size <= LOCAL_SHARD_THRESHOLD_MB * MB) {
            return await this.uploadLocalSmall(file, { onProgress })
          }
          return await this.uploadLocalSharded(file, { onProgress })

        }else if (this.uploadType === 3) {
        // 云直传：统一通过后端下发凭证/预签名 URL
        // S3: 使用预签名 URL 直传（支持分片）
          return await this.uploadS3(file, { onProgress })
        }else {
          return await this.uploadCloudSingle(file, { onProgress })
      }

    }
  }
  // ---------------------- 本地直传（小文件） ----------------------
  async uploadLocalSmall(file, { onProgress } = {}) {
    const form = new FormData()
    form.append("file", file)
    form.append("usageScene",this.usageScene )
    form.append("fileMd5",file.fileMd5)


    const controller = createAbortController()
    if (controller) this.currentControllers.add(controller)

    // 保存上传任务信息（小文件上传没有 shardUploadId，但可以通过 AbortController 取消）
    if (file.fileMd5) {
      this.currentUploadTasks.set(file.fileMd5, {
        type: 0, // 本地上传
        controller: controller
      })
    }

    try {
      const res = await Axios.post("/etv/uploadFile.json", form, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (evt) => {
          if (!onProgress || !evt.total) return

          onProgress(Math.floor((evt.loaded / evt.total) * 100))
        },
        signal: controller?controller.signal:'',
      })
      // 期望返回 { fileId, url? }
      // 上传成功，清除任务信息
      if (file.fileMd5) {
        this.currentUploadTasks.delete(file.fileMd5)
      }
      if (res.data.code === 1) {
        file.msg = res.data.msg
        Toast(file.msg)
        return
      }
      return {
        result:res.data.data.fileId || res.data.data || '',
      }
    } catch (error) {
      // 上传失败，清除任务信息
      if (file.fileMd5) {
        this.currentUploadTasks.delete(file.fileMd5)
      }
      throw error
    } finally {
      if (controller) this.currentControllers.delete(controller)
    }
  }

  // ---------------------- 本地直传（大文件分片） ----------------------
  async uploadLocalSharded(file, { onProgress } = {}) {
    // 1) 初始化分片任务（JSON）

    const initResp = await instance.post(this.upFileUrl +"etv/createShardUploadTask.json", {
      fileName: file.name,
      partNum: file.totalChunks,
      fileMd5: file.fileMd5,
    })

    // 如果后端返回 fileId，说明文件已存在，直接返回 fileId 无需上传
    if(initResp.data.data && initResp.data.data.fileId){
      // 模拟进度条：快速从 0% 到 100%，让用户看到完整进度
      if (onProgress) {
        onProgress(0)
        // 使用 setTimeout 确保 UI 有时间更新
        setTimeout(() => {
          if (onProgress) onProgress(100)
        }, 100)
      }
      return {
        result: initResp.data.data.fileId || ''
      }
    }

    const shardUploadId = initResp.data.data.shardUploadId
    if (!shardUploadId) throw new Error("Missing shardUploadId from createShardUploadTask");

    // 创建主控制器并保存任务信息
    const mainController = createAbortController()
    const taskInfo = {
      type: 0,
      shardUploadId: shardUploadId,
      cancelled: false,
      mainController: mainController
    }
    this.currentUploadTasks.set(file.fileMd5, taskInfo)

    // 检查是否已取消（简化版）
    const isCancelled = () => {
      const task = this.currentUploadTasks.get(file.fileMd5)
      return !task || task.cancelled || mainController && mainController.signal && mainController.signal.aborted
    }

    // 2) 切片上传
    const partSize = LOCAL_PART_SIZE_MB * MB
    let uploadedBytes = 0

    try {
      for (let i = 0; i < file.totalChunks; i++) {
        if (isCancelled()) {
          this.currentUploadTasks.delete(file.fileMd5)
          throw new Error('上传已取消')
        }

        const blob = file.slice(i * partSize, Math.min((i + 1) * partSize, file.size))
        const buf = await blob.arrayBuffer()

        if (isCancelled()) {
          this.currentUploadTasks.delete(file.fileMd5)
          throw new Error('上传已取消')
        }

        const spark = new SparkMD5.ArrayBuffer()
        spark.append(buf)
        const chunkMd5 = spark.end()

        const form = new FormData()
        form.append("shardUploadId", shardUploadId)
        form.append("partOrder", String(i + 1))
        form.append("chunkMd5", chunkMd5)
        form.append("file", new Blob([buf], { type: "application/octet-stream" }))

        if (mainController) this.currentControllers.add(mainController)

        try {
          await instance.post(this.upFileUrl +"etv/uploadChunk.json", form, {
            headers: { "Content-Type": "multipart/form-data" },
            signal: mainController ? mainController.signal : undefined,
          })

          if (isCancelled()) {
            this.currentUploadTasks.delete(file.fileMd5)
            throw new Error('上传已取消')
          }

          uploadedBytes += blob.size
          if (onProgress) onProgress(Math.floor((uploadedBytes / file.size) * 100))
        } catch (error) {
          if (isCancelled() || error.message === '上传已取消') {
            this.currentUploadTasks.delete(file.fileMd5)
            throw new Error('上传已取消')
          }
          throw error
        }
      }
    } finally {
      if (mainController) this.currentControllers.delete(mainController)
    }

    // 合并前检查
    if (isCancelled()) {
      this.currentUploadTasks.delete(file.fileMd5)
      throw new Error('上传已取消')
    }

    // 3) 合并分片（生成 fileId）
    const mergeResp = await instance.post(this.upFileUrl +"etv/mergeChunks.json", {
      shardUploadId:shardUploadId,
      usageScene:this.usageScene
    });
    // 后端约定 data 就是 fileId 或 {fileId}
    const merged = mergeResp.data.data

    // 上传成功，清除任务信息
    this.currentUploadTasks.delete(file.fileMd5)

    return {
      result:merged
    }
  }

// ---------------------- 云直传（单 URL PUT） ----------------------
  async uploadCloudSingle(file, { onProgress } = {}) {
    try {
      // 1) 获取上传凭证
      await this.checkAndUpdateCredentials()
      //重置防止拿到上一个的数据
      this.fileUrl = ''
      this.thumbUrl = ''
      file.onProgress = onProgress // 设置进度回调
      if(file.type.startsWith('image/')){
        const result  = await this.upFileImage(file)
        this.fileUrl = result.fileUrl
        this.thumbUrl = result.thumbUrl
      }else {
        this.fileUrl  = await this.upFileDefault(file)
      }


      if (!this.fileUrl) {
        console.log('文件上传失败：未获取到文件URL')
        return ''
      }
      if(this.uploadType === 1){
        this.fileUrl = getSafeUrl(this.fileUrl)
        this.thumbUrl = getSafeUrl(this.thumbUrl)
      }
      // 上传成功后的回调
      const cbRes = await instance.post(this.upFileUrl +"etv/fileCallback.json", {
        uploadType: this.uploadType,
        fileName: file.name,
        usageScene: this.usageScene,
        fileSize: file.size,
        fileUrl: this.fileUrl,
        fileMd5: file.fileMd5 || '',
        fileType: file.type,
        thumbUrl: this.thumbUrl || ''
      })

      if(this.usageScene !== 1){
        return {
          result: cbRes.data.data || '',
          fileUrl: this.fileUrl,
        }
      }else {
        return {
          result:cbRes.data.data || '',
        }
      }



    } catch (error) {
      console.error('文件上传失败:', error);
      throw new Error(`文件上传失败: ${error.message || '未知错误'}`);
    }
  }
  // ---------------------- 云直传S3（统一入口） ----------------------
  async uploadS3(file) {
    try {
      if(file.type.startsWith('image/')){
        const result  = await this.upFileImage(file)
        this.fileUrl = result.fileUrl
        this.thumbUrl = result.thumbUrl
      }else {
        this.fileUrl  = await this.upFileDefault(file)
      }

      // 检查是否已取消（在调用回调接口前检查）
      if (file.fileMd5) {
        const task = this.currentUploadTasks.get(file.fileMd5)
        if (task && task.cancelled) {
          throw new Error('上传已取消')
        }
      }

      if (!this.fileUrl) {
        console.log('文件上传失败：未获取到文件URL')
        return ''
      }

      // 上传成功后的回调
      const cbRes = await Axios.post("/etv/fileCallback.json", {
        uploadType: this.uploadType,
        fileName: file.name,
        usageScene: this.usageScene,
        fileSize: file.size,
        fileUrl: this.fileUrl,
        fileMd5: file.fileMd5 || '',
        fileType: file.type,
        thumbUrl: this.thumbUrl || ''
      })

      if(this.usageScene !== 1){
        return {
          result:cbRes.data.data || '',
          fileUrl: this.fileUrl,
        }
      }else {
        return {
          result:cbRes.data.data || ''
        }
      }
    } catch (error) {
      // 如果是取消错误，直接抛出，不进行包装
      if (error.message === '上传已取消' ) {
        throw error
      }

      throw new Error(`S3文件上传失败: ${error.message || '未知错误'}`)
    }
  }


  // 统一错误处理和重试方法
  async retryUploadWithCredentials(uploadFn, maxRetries = 3) {
    let lastError = null

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        // 每次重试前重新获取凭证（仅对COS/OSS有效）
        if (this.uploadType === 1 || this.uploadType === 2) {
          await this.checkAndUpdateCredentials()
        }

        // 执行上传操作
        return await uploadFn()
      } catch (error) {
        lastError = error
        
        // 检查是否是取消错误（CancelToken 取消或 AbortController 取消）
        // 如果是取消错误，直接抛出，不重试
        if (Axios.isCancel && Axios.isCancel(error)) {
          throw error // 直接抛出取消错误，不重试
        }
        if (error.name === 'AbortError' || error.message === 'canceled' || error.message === '取消 OSS 上传' || error.message === '上传已取消') {
          throw error // 直接抛出取消错误，不重试
        }
        
        console.error(`上传失败 (尝试 ${attempt}/${maxRetries}):`, error)

        // 如果是凭证错误，清除凭证强制重新获取
        if (this.uploadType === 1 || this.uploadType === 2) {
          const uploadService = this.uploadType === 1 ? 'cosExpireTime' : 'ossExpireTime'
          removeLocalStorageForUser(this.TOKEN_VALUE, uploadService)
          // 清除所有相关凭证
          if (this.uploadType === 1) {
            const cosKeys = ['bucketName', 'region', 'tmpSecretId', 'tmpSecretKey', 'sessionToken', 'pathPrefix']
            cosKeys.forEach(key => removeLocalStorageForUser(this.TOKEN_VALUE, key))
          } else if (this.uploadType === 2) {
            const ossKeys = ['dir', 'host', 'policy', 'security_token', 'signature', 'version', 'x_oss_credential', 'x_oss_date', 'pathPrefix']
            ossKeys.forEach(key => removeLocalStorageForUser(this.TOKEN_VALUE, key))
          }
        }

        // 如果已经是最后一次尝试，不再重试
        if (attempt === maxRetries) {
          throw new Error(`上传失败（已重试${maxRetries}次）: ${error.message || '未知错误'}`)
        }

        // 等待一段时间再重试（递增延迟：1秒、2秒、3秒）
        await new Promise(resolve => setTimeout(resolve, 1000 * attempt))
      }
    }

    // 理论上不会到这里，但为了安全起见
    throw new Error(`上传失败（已重试${maxRetries}次）: ${lastError?lastError.message : '未知错误'}`)
  }

// 获取并更新凭证
  async checkAndUpdateCredentials() {
    const uploadService = this.uploadType === 1 ? 'cosExpireTime' :
        (this.uploadType === 2 ? 'ossExpireTime' : '');

    if (!uploadService) return;

    const expireTime = getLocalStorageForUser(this.TOKEN_VALUE, uploadService);
    const currentTimeInSeconds = Math.floor(Date.now() / 1000) + 60;
    console.log('expireTime：',expireTime,'currentTimeInSeconds',currentTimeInSeconds,isTimestampExpired(expireTime))
    if (expireTime === 'undefined' || isTimestampExpired(expireTime)) {
      try {
        const res = await Axios.post("/etv/getUploadCredential.json");
        const data = decode(res.data)

        if (data === null) {
          throw new Error('获取上传凭证失败');
        }

        if (this.uploadType === 1) {
          // COS凭证处理
          const cosKeys = [
            "bucketName",
            "region",
            "tmpSecretId",
            "tmpSecretKey",
            "sessionToken",
            "expireTime",
            "pathPrefix"
          ];

          cosKeys.forEach(key => {
            if (data[key] !== undefined) {
              const storageKey = key === "expireTime" ? "cosExpireTime" : key;

              setLocalStorageForUser(this.TOKEN_VALUE, storageKey, data[key]);
            }
          });

          getCosUploading(true);
        } else if (this.uploadType === 2) {
          // OSS凭证处理
          const ossKeys = [
            "dir",
            "expireTime",
            "host",
            "policy",
            "security_token",
            "signature",
            "version",
            "x_oss_credential",
            "x_oss_date",
            "pathPrefix"
          ];

          ossKeys.forEach(key => {
            if (data[key] !== undefined) {
              const storageKey = key === "expireTime" ? "ossExpireTime" : key;

              setLocalStorageForUser(this.TOKEN_VALUE, storageKey, data[key]);
            }
          });
        }
      } catch (error) {
        console.error("获取上传凭证失败:", error);
        throw new Error(`获取上传凭证失败: ${error.message || '未知错误'}`);
      }
    }
  }


  async upFileImage(file) {
    return new Promise((resolve, reject) => {
      let originalUrl = ''
      let thumbUrl = ''
      let totalProgress = 0

      // 更新进度
      const updateProgress = (step, progress) => {
        // 缩略图上传占30%权重，原图上传占70%权重
        const currentProgress = step === 'thumb'
            ? Math.round(progress * 0.3 * 100)
            : 30 + Math.round(progress * 0.7 * 100)

        // 确保进度只增不减
        if (currentProgress > totalProgress) {
          totalProgress = currentProgress
          if (file.onProgress) {
            file.onProgress(totalProgress)
          }
        }
      }

      // 1. 先上传缩略图
      new Compressor(file, {
        quality: 0.6,
        maxWidth: 200,
        maxHeight: 200,
        convertSize: 1000000,
        success: async (compressedFile) => {
          // 如果压缩后的文件没有 fileMd5，使用原文件的 fileMd5
          if (!compressedFile.fileMd5 && file.fileMd5) {
            compressedFile.fileMd5 = file.fileMd5
          }
          try {

            if(this.uploadType === 1){
              // COS类型
              // 上传缩略图
              const thumbResult = await this.uploadToCos(compressedFile, (progress) => {
                updateProgress('thumb', progress / 100);
              });
              thumbUrl = thumbResult.Location

              // 2. 上传原图
              const originalResult = await this.uploadToCos(file, (progress) => {
                updateProgress('original', progress / 100);
              });
              originalUrl = originalResult.Location
            }else if(this.uploadType === 2){
              // OSS类型
              // 上传缩略图
              const thumbResult = await this.uploadToOss(compressedFile, (progress) => {
                updateProgress('thumb', progress)
              })
              thumbUrl = thumbResult.Location

              // 2. 上传原图
              const originalResult = await this.uploadToOss(file, (progress) => {
                updateProgress('original', progress)
              })
              originalUrl = originalResult.Location

            }else {

              //S3类型
              // 上传缩略图
              const thumbResult = await this.uploadS3Single(compressedFile, (progress) => {
                updateProgress('thumb', progress)
              })
              thumbUrl = thumbResult.Location

              // 2. 上传原图
              const originalResult = await this.uploadS3Single(file, (progress) => {
                updateProgress('original', progress)
              })
              originalUrl = originalResult.Location
            }


            // 3. 确保最终进度为100%
            if (file.onProgress) {
              file.onProgress(100)
            }

            // 4. 返回两个URL
            resolve({
              fileUrl: originalUrl,
              thumbUrl: thumbUrl
            })
          } catch (error) {
            console.error('上传失败:', error)
            reject(error)
          }
        },
        error: (err) => {
          console.error('缩略图生成失败:', err)
          reject(err)
        }
      })
    })
  }
  // 上传到COS\OSS（根据 uploadType 选择）
  async upFileDefault(file) {

    let originalUrl = ''
    if (this.uploadType === 1) {
      // COS 上传
      const originalResult = await this.uploadToCos(file, (progress) => {
        if (file.onProgress) {
          file.onProgress(Math.floor(progress * 100))
        }
      })
      originalUrl = originalResult.Location
    } else if (this.uploadType === 2) {
      // OSS 上传
      const originalResult = await this.uploadToOss(file, (progress) => {
        if (file.onProgress) {
          file.onProgress(Math.floor(progress * 100))
        }
      })
      originalUrl = originalResult.Location
    } else {
      // S3 上传
      const originalResult = await this.uploadS3Single(file, (progress) => {
        if (file.onProgress) {
          file.onProgress(Math.floor(progress * 100))
        }
      })
      originalUrl = originalResult.Location
    }

    // 4. 返回两个URL
    return originalUrl


  }

  // 上传文件到COS的辅助方法（带重试）
  async uploadToCos(file, onProgress) {
    return await this.retryUploadWithCredentials(async () => {
      const suffix = getFileSuffix(file.name)
      const type = '.' + suffix.toLowerCase()
      const typeUpload = classifyFileTypes(type)
      const primaryName = generateFilePath(type, typeUpload,this.TOKEN_VALUE)

      return new Promise((resolve, reject) => {

        const cosInstance = getCosUploading()

        // 进度回调
        const handleProgress = (progressData) => {
          if (onProgress && progressData && progressData.percent !== undefined) {
            onProgress(progressData.percent)
          }
        }

        // 完成回调
        const handleFileFinish = (err) => {
          if (err) {
            reject(err)
            return
          }
          // 这里不 resolve，等待 onSuccess 回调
        }

        // 最终完成回调
        const handleSuccess = (err, data) => {
          // 上传完成，清除任务信息
          if (file.fileMd5) {
            this.currentUploadTasks.delete(file.fileMd5)
          }

          if (err) {
            // 上传失败，也要清除任务信息
            if (file.fileMd5) {
              this.currentUploadTasks.delete(file.fileMd5)
            }
            reject(err)
            return
          }
          resolve({ Location: data.Location || data })
        }

        // 保存上传任务信息（在开始上传前）
        const taskInfo = {
          type: 1, // COS上传
          cosTaskId: null,
          cosInstance: cosInstance
        }
        if (file.fileMd5) {
          this.currentUploadTasks.set(file.fileMd5, taskInfo)
        }

        // 调用 COS SDK 的方法来上传文件并获取 taskId
        cosInstance.cos.uploadFile({
          Bucket: getLocalStorageForUser(this.TOKEN_VALUE, "bucketName"),
          Region: getLocalStorageForUser(this.TOKEN_VALUE, "region"),
          Key: primaryName,
          Body: file,
          ContentType: file.type,
          SliceSize: 1024 * 1024 * 5,
          onTaskReady: (taskId) => {

            // 更新任务信息
            if (file.fileMd5) {
              taskInfo.cosTaskId = taskId
              this.currentUploadTasks.set(file.fileMd5, taskInfo)
            }
          },
          onProgress: handleProgress,
          onFileFinish: handleFileFinish,
        }, handleSuccess)
      })
    })
  }

  // 上传文件到OSS的辅助方法（带重试）
  async uploadToOss(file, onProgress) {
    return await this.retryUploadWithCredentials(async () => {
      // 检查是否已取消（在重试前检查）
      if (file.fileMd5) {
        const task = this.currentUploadTasks.get(file.fileMd5)
        if (task && task.cancelled) {
          throw new Error('上传已取消')
        }
      }

      const suffix = getFileSuffix(file.name)
      const type = '.' + suffix.toLowerCase()
      const typeUpload = classifyFileTypes(type)
      const primaryName = generateFilePath(type, typeUpload,this.TOKEN_VALUE)

      // 使用 axios CancelToken 实现可取消的上传（兼容 Vue2 项目常用的 axios 版本）
      const CancelToken = Axios.CancelToken
      const source = CancelToken.source()

      // 保存上传任务信息，供 cancelUpload 使用
      if (file.fileMd5) {
        this.currentUploadTasks.set(file.fileMd5, {
          type: 2, // OSS上传
          ossCancelSource: source,
          cancelled: false
        })
      }

      try {
        // 再次检查是否已取消（在发送请求前）
        if (file.fileMd5) {
          const task = this.currentUploadTasks.get(file.fileMd5)
          if (task && task.cancelled) {
            throw new Error('上传已取消')
          }
        }

        let fileData = new FormData()
        fileData.append("success_action_status", "200")
        fileData.append("policy", getLocalStorageForUser(this.TOKEN_VALUE, 'policy'))
        fileData.append("x-oss-signature", getLocalStorageForUser(this.TOKEN_VALUE, 'signature'))
        fileData.append("x-oss-signature-version", getLocalStorageForUser(this.TOKEN_VALUE, 'version'))
        fileData.append("x-oss-credential", getLocalStorageForUser(this.TOKEN_VALUE, 'x_oss_credential'))
        fileData.append("x-oss-date", getLocalStorageForUser(this.TOKEN_VALUE, 'x_oss_date'))
        fileData.append("key", primaryName)
        fileData.append("x-oss-security-token", getLocalStorageForUser(this.TOKEN_VALUE, 'security_token'))
        fileData.append("file", file)

        const uploadResult = await instance.post(
            getLocalStorageForUser(this.TOKEN_VALUE, 'host'),
            fileData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              cancelToken: source.token,
              onUploadProgress: (evt) => {
                if (onProgress && evt.total) {
                  const progress = (evt.loaded / evt.total)
                  onProgress(progress)
                }
              }
            }
        )

        if (uploadResult.status === 200) {
          // 上传成功，清除任务信息
          if (file.fileMd5) {
            this.currentUploadTasks.delete(file.fileMd5)
          }

          const host = getLocalStorageForUser(this.TOKEN_VALUE, 'host')
          const fileUrl = ensureTrailingSlash(host) + primaryName
          return { Location: fileUrl }
        } else {
          throw new Error('OSS上传失败：服务器返回非200状态')
        }
      } catch (error) {
        // 如果是取消错误，直接抛出，不进行重试
        if (Axios.isCancel && Axios.isCancel(error)) {
          if (file.fileMd5) {
            this.currentUploadTasks.delete(file.fileMd5)
          }
          throw error
        }
        if (error.message === '上传已取消') {
          if (file.fileMd5) {
            this.currentUploadTasks.delete(file.fileMd5)
          }
          throw error
        }
        // 其他错误继续抛出，让重试机制处理
        throw error
      } finally {
        // 清理任务信息（如果还在的话）
        if (file.fileMd5) {
          const task = this.currentUploadTasks.get(file.fileMd5)
          if (task && task.ossCancelSource === source) {
            // 只有在任务还存在且是我们创建的 source 时才清理
            // 如果已经在上传成功或取消时清理了，这里就不需要再清理
          }
        }
      }
    })
  }


  // S3 单文件上传（自动判断是否需要分片）
  async uploadS3Single(file, onProgress) {
    const threshold = S3_MIN_PART_SIZE_MB * MB

    // 判断文件大小，决定使用单次上传还是分片上传
    if (file.size > threshold) {
      // 大文件：使用分片上传
      return await this.uploadS3Multipart(file, onProgress)
    } else {
      // 小文件：使用单次上传
      return await this.uploadS3SingleDirect(file, onProgress)
    }

  }

  // S3 单次直传（小文件，带重试）
  async uploadS3SingleDirect(file, onProgress) {
    const maxRetries = 3
    let lastError = null
    
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      // 检查是否已取消
      if (file.fileMd5) {
        const task = this.currentUploadTasks.get(file.fileMd5)
        if (task && task.cancelled) {
          throw new Error('上传已取消')
        }
      }
      
      const controller = createAbortController()
      if (controller) this.currentControllers.add(controller)
      
      try {
        // 1) 获取预签名URL（每次重试都重新获取）
        const res = await Axios.post("/etv/generatePreSignedUrl.json", {
          originalFileName: file.name,
          fileSize: file.size.toString(),
          contentType: detectContentType(file),
          fileMd5:file.fileMd5
        })

        if (!res.data || !res.data.data) {
          throw new Error('获取预签名URL失败')
        }

        const url = res.data.data

        // 再次检查是否已取消
        if (file.fileMd5) {
          const task = this.currentUploadTasks.get(file.fileMd5)
          if (task && task.cancelled) {
            if (controller) controller.abort()
            throw new Error('上传已取消')
          }
        }

        // 2) 使用预签名URL上传文件
        await instance.put(url, file, {
          headers: {
            "Content-Type": detectContentType(file)
          },
          onUploadProgress: (evt) => {
            // 在进度回调中检查取消状态
            if (file.fileMd5) {
              const task = this.currentUploadTasks.get(file.fileMd5)
              if (task && task.cancelled) {
                if (controller) controller.abort()
                return
              }
            }
            if (onProgress && evt.total) {
              const progress = (evt.loaded / evt.total)
              onProgress(progress)
            }
          },
          signal: controller?controller.signal:'',
        })

        // 检查是否已取消（上传完成后）
        if (file.fileMd5) {
          const task = this.currentUploadTasks.get(file.fileMd5)
          if (task && task.cancelled) {
            throw new Error('上传已取消')
          }
        }
        
        const fileUrl = url.split('?')[0] // 去除URL参数

        // 返回文件URL，由调用方决定是否上报
        return { Location: fileUrl }
      } catch (error) {
        // 如果是取消错误，直接抛出，不重试
        if (error.message === '上传已取消' || error.name === 'AbortError' || error.message === 'canceled' || error.code === 'ERR_CANCELED') {
          // 检查是否真的是取消操作
          if (file.fileMd5) {
            const task = this.currentUploadTasks.get(file.fileMd5)
            if (task && task.cancelled) {
              throw new Error('上传已取消')
            }
          }
        }
        
        lastError = error
        console.error(`S3单次上传失败 (尝试 ${attempt}/${maxRetries}):`, error)
        
        // 如果已经是最后一次尝试，不再重试
        if (attempt === maxRetries) {
          throw new Error(`S3单次上传失败（已重试${maxRetries}次）: ${error.message || '未知错误'}`)
        }
        
        // 等待一段时间再重试（递增延迟）
        await new Promise(resolve => setTimeout(resolve, 1000 * attempt))
      } finally {
        if (controller) this.currentControllers.delete(controller)
      }
    }
    
    // 理论上不会到这里，但为了安全起见
    throw new Error(`S3单次上传失败（已重试${maxRetries}次）: ${lastError ? lastError.message : '未知错误'}`)
  }

  // S3 分片上传（大文件）
  async uploadS3Multipart(file, onProgress) {
    try {
      const partSize = choosePartSize(file.size, S3_MIN_PART_SIZE_MB)
      const totalParts = Math.ceil(file.size / partSize)


      // 1) 初始化分片上传
      const initRes = await Axios.post("/etv/createMultipartUpload.json", {
        originalFileName: file.name,
        fileSize: file.size,
        contentType: detectContentType(file),
        fileMd5:file.fileMd5
      })

      // 初始化后立即检查是否已取消
      if (file.fileMd5) {
        const checkTask = this.currentUploadTasks.get(file.fileMd5)
        if (checkTask && checkTask.cancelled) {
          throw new Error('上传已取消')
        }
      }

      if (!initRes.data || !initRes.data.data ) {
        throw new Error('初始化分片上传失败')
      }

      const { shardUploadId } = initRes.data.data
      
      // 保存上传任务信息
      const taskInfo = {
        type: 3, // S3上传
        shardUploadId: shardUploadId,
        cancelled: false, // 取消标志
        partCancelSources: [] // 保存所有分片上传的 CancelToken Source，用于取消时中断所有请求
      }
      if (file.fileMd5) {
        this.currentUploadTasks.set(file.fileMd5, taskInfo)
      }
      
      const uploadedParts = []
      let uploadedBytes = 0

      // 获取所有分片的预签名URL
      const response = await Axios.get(`/etv/getPartPreSignedUrl.json?shardUploadId=${shardUploadId}&partCount=${totalParts}`)

      // 获取预签名URL后立即检查是否已取消
      if (file.fileMd5) {
        const checkTask = this.currentUploadTasks.get(file.fileMd5)
        if (checkTask && checkTask.cancelled) {
          throw new Error('上传已取消')
        }
      }


      const partUrlsObject = response.data.data.urls

      // 辅助函数：检查是否已取消
      const checkCancelled = () => {
        if (!file.fileMd5) return false
        const task = this.currentUploadTasks.get(file.fileMd5)
        return task && task.cancelled
      }

      // 2) 上传每个分片
      // 在循环开始和每次迭代时检查取消状态，如果已取消则立即停止
      for (let partNumber = 1; partNumber <= totalParts; partNumber++) {
        // 在每次循环开始时检查取消状态
        if (checkCancelled()) {
          console.log(`S3 分片上传已取消，停止在第 ${partNumber}/${totalParts} 个分片`)
          const task = this.currentUploadTasks.get(file.fileMd5)
          // 中断所有已创建的分片 CancelToken Source
          if (task && task.partCancelSources && task.partCancelSources.length > 0) {
            task.partCancelSources.forEach(source => {
              try {
                if (source && typeof source.cancel === 'function') {
                  source.cancel('S3 上传已取消')
                }
              } catch (e) {
                // 忽略错误
              }
            })
          }
          this.currentUploadTasks.delete(file.fileMd5)
          throw new Error('上传已取消')
        }
        
        const start = (partNumber - 1) * partSize
        const end = Math.min(start + partSize, file.size)
        const partBlob = file.slice(start, end)

        // 获取当前分片的URL（urls 是对象，键是 partNumber）
        const currentPartUrl = partUrlsObject[partNumber]

        if (!currentPartUrl) {
          throw new Error(`未找到分片${partNumber}的预签名URL`)
        }

        // 使用 CancelToken 而不是 AbortController（更可靠）
        const CancelToken = Axios.CancelToken
        const cancelSource = CancelToken.source()
        
        // 将 CancelToken Source 保存到任务信息中，方便取消时统一中断
        if (file.fileMd5) {
          const currentTask = this.currentUploadTasks.get(file.fileMd5)
          if (currentTask && currentTask.partCancelSources) {
            currentTask.partCancelSources.push(cancelSource)
          }
        }

        try {
          // 在创建请求前再次检查取消状态
          if (checkCancelled()) {
            cancelSource.cancel('S3 上传已取消')
            this.currentUploadTasks.delete(file.fileMd5)
            throw new Error('上传已取消')
          }

          // 上传分片（使用 CancelToken 取消请求）
          const uploadRes = await instance.put(currentPartUrl, partBlob, {
            headers: {
              "Content-Type": detectContentType(file)
            },
            cancelToken: cancelSource.token, // 使用 CancelToken
            onUploadProgress: (evt) => {
              // 在进度回调中检查取消状态，如果已取消则立即中断
              if (checkCancelled()) {
                cancelSource.cancel('S3 上传已取消')

                return
              }
              if (onProgress && evt.total) {
                const currentPartProgress = evt.loaded
                const totalProgress = (uploadedBytes + currentPartProgress) / file.size
                onProgress(totalProgress)
              }
            },
          })

          // 上传完成后立即检查取消状态
          if (checkCancelled()) {

            this.currentUploadTasks.delete(file.fileMd5)
            throw new Error('上传已取消')
          }

          // 获取 ETag
          const etag = uploadRes.headers['etag'] || uploadRes.headers['ETag']
          if (!etag) {
            throw new Error(`分片${partNumber}上传成功但未获取到ETag`)
          }

          uploadedParts.push({
            partNumber: partNumber,
            eTag: etag.replace(/"/g, '') // 移除引号
          })

          uploadedBytes += (end - start)

        } catch (error) {
          // 如果是取消错误，检查取消标志
          const isCancelError = Axios.isCancel && Axios.isCancel(error) || 
                               error.name === 'AbortError' || 
                               error.message === 'canceled' || 
                               error.code === 'ERR_CANCELED' || 
                               error.message === '上传已取消' ||
                               error.message === 'S3 上传已取消'
          if (isCancelError) {
            if (checkCancelled()) {

              // 从任务 CancelToken Source 数组中移除
              if (file.fileMd5) {
                const currentTask = this.currentUploadTasks.get(file.fileMd5)
                if (currentTask && currentTask.partCancelSources) {
                  const index = currentTask.partCancelSources.indexOf(cancelSource)
                  if (index > -1) {
                    currentTask.partCancelSources.splice(index, 1)
                  }
                }
                this.currentUploadTasks.delete(file.fileMd5)
              }
              throw new Error('上传已取消')
            }
          }
          // 如果不是取消错误，继续抛出原始错误
          throw error
        } finally {
          // 从任务 CancelToken Source 数组中移除已完成的
          if (file.fileMd5) {
            const currentTask = this.currentUploadTasks.get(file.fileMd5)
            if (currentTask && currentTask.partCancelSources) {
              const index = currentTask.partCancelSources.indexOf(cancelSource)
              if (index > -1) {
                currentTask.partCancelSources.splice(index, 1)
              }
            }
          }
        }
      }

      // 检查是否已取消上传（在合并前检查）
      // 如果已取消，不调用合并接口，让后端通过 shardUploadId 清理未完成的分片
      if (checkCancelled()) {
         this.currentUploadTasks.delete(file.fileMd5)
        throw new Error('上传已取消')
      }

      // 3) 完成分片上传（合并所有分片）
      // 再次检查取消状态（在发送合并请求前）
      if (checkCancelled()) {
         this.currentUploadTasks.delete(file.fileMd5)
        throw new Error('上传已取消')
      }
      
      const completeRes = await Axios.post("/etv/completeMultipartUpload.json", {
        shardUploadId:shardUploadId,
        parts: uploadedParts
      })

      // 合并完成后再次检查（防止合并过程中被取消）
      if (checkCancelled()) {
         this.currentUploadTasks.delete(file.fileMd5)
        throw new Error('上传已取消')
      }

      if (!completeRes.data || !completeRes.data.data) {
        throw new Error('完成分片上传失败')
      }

      const fileUrl =  completeRes.data.data? completeRes.data.data :''

      // 上传成功，清除任务信息
      if (file.fileMd5) {
        this.currentUploadTasks.delete(file.fileMd5)
      }

      // 确保进度为100%
      if (onProgress) {
        onProgress(1)
      }

      return { Location: fileUrl }

    } catch (error) {

      // 如果上传失败且已初始化分片上传，输出警告日志提示后端需要清理未完成的分片
      if (file.fileMd5) {
        // 清除任务信息
        this.currentUploadTasks.delete(file.fileMd5)
      }
      
      throw error
    }
  }


}

const uploadService = new UploadService();
export default uploadService;


